import { createAsyncReducer } from '@telstra-connect/standard-actions/reducers';
import {
    IGetCustomerCustomPropsAction,
    IGetCustomerCustomPropsNotStartedAction,
    IGetCustomerCustomPropsSuccessAction,
    IGetCustomerCustomPropsErrorAction
} from '../actions/get-customer-custom-props';
import { IOpsHubState } from '../state';
import { initialState } from '@telstra-connect/ops-hub/state/initial-state';

export type GetCustomerCustomPropsAction
    = IGetCustomerCustomPropsAction
    | IGetCustomerCustomPropsNotStartedAction
    | IGetCustomerCustomPropsSuccessAction
    | IGetCustomerCustomPropsErrorAction;

const init = (state: IOpsHubState, action: GetCustomerCustomPropsAction) => ({
    ...state,
    customerCustomProps: {
        ...initialState.customerCustomProps,
        status: action.status
    }
});

const success = (state: IOpsHubState, action: GetCustomerCustomPropsAction) => {
    return {
        ...state,
        customerCustomProps: {
            ...initialState.customerCustomProps,
            status: action.status,
            data: (action as IGetCustomerCustomPropsSuccessAction).data
        }
    };
};

const failure = (state: IOpsHubState, action: GetCustomerCustomPropsAction) => ({
    ...state,
    customerCustomProps: {
        ...initialState.customerCustomProps,
        status: action.status,
        error: (action as IGetCustomerCustomPropsErrorAction).error
    }
});

const reset = (state: IOpsHubState, action: GetCustomerCustomPropsAction) => {
    return {
        ...state,
        customerCustomProps: {
            ...initialState.customerCustomProps,
            status: action.status,
            error: null
        }
    };
};

export const getCustomerCustomPropsReducer = createAsyncReducer(initialState, init, success, failure, reset);
